function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 12.25c-1.52 0-2.75-1.23-2.75-2.75S10.48 6.75 12 6.75s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75zm0-4a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-.01 6.47c-.8 0-1.6-.18-2.33-.55a.75.75 0 01-.33-1.01c.18-.37.63-.52 1.01-.33 1.04.52 2.28.52 3.32 0 .36-.18.82-.04 1 .32.19.36.06.81-.3 1-.75.38-1.56.57-2.37.57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 17.25c-.22 0-.44-.1-.59-.28L12 15.19l-1.41 1.78a.747.747 0 11-1.17-.93l2-2.53c.28-.36.89-.36 1.18 0l2 2.53c.26.33.2.8-.12 1.05-.15.11-.32.16-.48.16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
})));